/**
 * Service task primary lists (intr003 / intr010) — progressive session invalidation signals.
 */

export const SERVICE_TASK_LIST_INVALIDATED_EVENT = 'service_task_list:invalidated';

export const SESSION_SAFE_UPDATE = 'SESSION_SAFE_UPDATE';
export const SESSION_INVALIDATING = 'SESSION_INVALIDATING';

export function dispatchServiceTaskListInvalidated(detail = {}) {
  if (typeof window === 'undefined' || typeof window.dispatchEvent !== 'function') return;
  window.dispatchEvent(new CustomEvent(SERVICE_TASK_LIST_INVALIDATED_EVENT, { detail }));
}

/**
 * Detail payload from ServiceTaskDetail is not a table-complete list_row — always invalidate.
 */
export function classifyServiceTaskDetailListMutation(taskPayload) {
  if (!taskPayload || taskPayload.id == null) return SESSION_INVALIDATING;
  return SESSION_INVALIDATING;
}

export function applyPagedMutationOverlay(response, overlay) {
  if (!response || typeof response !== 'object' || !Array.isArray(response.data)) return response;
  if (!overlay || typeof overlay.get !== 'function' || overlay.size === 0) return response;
  return {
    ...response,
    data: response.data.map((row) => {
      if (!row) return row;
      const key = row.list_row_id ?? row.id;
      if (key == null) return row;
      return overlay.get(String(key)) || row;
    }),
  };
}
